import React, { useState, useEffect } from 'react';
import { InsurancePlan, Network, NetworkStatus, SelectedNetwork } from '../../utils/types';
import Button from '@mui/material/Button';
import { ButtonArrayContainer, ButtonContainer, InlineButtonContainer, buttonStyles, notSureStyles, NotSureButtonContainer, SectionHeader } from '../../theme';
import NotSureNetworkModal from '../Modals/NotSureNetworkModal';
import { EventAction, trackMixpanelEvent } from '../../mixpanelAnalytics';

type Props = {
    plan: InsurancePlan | null | undefined;
    handleNetworkSelect: (network: SelectedNetwork) => void;
};

export const availableNetworks = (plan:InsurancePlan):SelectedNetwork[] => {
    return [ { network: Network.PPO, status: plan.ppo }, { network: Network.HMO, status: plan.hmo }, { network: Network.EPO, status: plan.epo }, { network: Network.POS, status: plan.pos } ].filter(n => n.status !== NetworkStatus.NotAvailable);
};

const NetworksContainer = ({ plan, handleNetworkSelect }:Props): JSX.Element => {
    const [ open, setOpen ] = useState(false);
    const [ networks, setNetworks ] = useState<SelectedNetwork[]>();

    useEffect(() => {
        if (plan) {
            const networks = availableNetworks(plan);
            setNetworks(networks);
            // If only one network is offered, skip this step and select the network
            if (networks.length === 1) {
                handleNetworkSelect(networks[0]);
            }
        }
    }, []);

    const handleNotSure = () => {
        setOpen(!open);
        trackMixpanelEvent(EventAction.NOT_SURE_SELECTED, { selected: 'Network' });
    };

    if (!plan) {
        return (<div></div>);
    }
    return (
        <>
            <ButtonArrayContainer>
                <SectionHeader>Please select type:</SectionHeader>
                <ButtonContainer>
                    <InlineButtonContainer>
                        {
                            networks?.map((n:SelectedNetwork, i:number) => (
                                <Button key={i} sx={buttonStyles} variant='contained' onClick={() => { handleNetworkSelect(n); }}>{n.network.toUpperCase()}</Button>
                            ))
                        }
                    </InlineButtonContainer>
                    <NotSureButtonContainer>
                        <Button onClick={handleNotSure} variant='text' sx={notSureStyles}>Not Sure?</Button>
                    </NotSureButtonContainer>
                </ButtonContainer>
            </ButtonArrayContainer>
            <NotSureNetworkModal open={open} handleClose={() => { setOpen(false); }}/>
        </>
    );
};

export default NetworksContainer;
